import { render, staticRenderFns } from "./ListNational.vue?vue&type=template&id=5b10e5c9&"
import script from "./ListNational.vue?vue&type=script&lang=js&"
export * from "./ListNational.vue?vue&type=script&lang=js&"
import style0 from "./ListNational.vue?vue&type=style&index=0&id=5b10e5c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports